import React, { useState, useEffect } from 'react';
import { 
  FileCopy 
} from '@mui/icons-material';

import FabButton from "@components/input/buttons/FabButton";
import { Button } from '@mui/material';

interface Props {
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export default function CopyButton({ 
  disabled = false,
  label = "",
  onClick 
}: Props) {
  const [is_disabled, setDisabled] = useState(disabled);

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  const className =`${is_disabled ? " disabled" : ""}`;

  if (label === "") {
    return (
      <FabButton
        disabled={disabled} 
        onClick={onClick}>
        <FileCopy/>
      </FabButton>
    );
  } else {
    return (
      <Button
        className={className}
        disabled={disabled} 
        onClick={onClick}
        variant="contained" color="primary">
        <FileCopy/>&nbsp;{ label }
      </Button>
    );
  }
}
